export default function Toast({ show, type, message, onClose }) {
    if (!show) return null;

    return (
        <div className="toast-container position-fixed bottom-0 end-0 p-3" style={{ zIndex: 9999 }}>
            <div
                className={`toast show align-items-center text-white border-0 ${type === "success" ? "bg-success" : "bg-danger"
                    }`}
                role="alert"
            >
                <div className="d-flex">
                    <div className="toast-body fw-bold">
                        {type === "success" ? "Success" : "Deleted"}: {message}
                    </div>
                    <button
                        type="button"
                        className="btn-close btn-close-white me-2 m-auto"
                        onClick={onClose}
                    ></button>
                </div>
            </div>
        </div>
    );
}